export var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
  return value != null;
};